const getSize = (size) => {
    const sizeMap = {
        '8xl': 'x8xl',
        '4xl': 'x4xl',
        xxl: 'xxl',
        xl: 'xl',
        large: 'large',
        medium: 'medium',
        small: 'small',
        xs: 'xs',
    };
    return sizeMap[size];
};

export { getSize as g };
